module.exports = __webpack_public_path__ + "static/media/passport.7b87038d.svg";